<template>
  <div>
    <h2 class="bb-page-title">Client Balance</h2>
    <div class="bb-client-balance">
      <transition name="fade" appear>
        <loader-fly v-if="loaderRun"/>
      </transition>
      <div class="bb-client-balance-totals">
        <total-card v-for="total in totalsInvoicesCard"
                    :key='total.id'
                    class="bb-client-balance-totals__item"
                    :title="total.title"
                    :icon="total.icon"
                    :sum="total.sum"
                    :info="total.info"
                    :colorSum="total.color"/>
      </div>
      <div class="bb-client-balance-menu">
        <i class="icon-menu bb-client-balance-menu-icon"
           @click="openMenu = !openMenu"
           v-click-outside="closeMenu">
          <transition name="slide-company">
            <div v-if="openMenu"
                 @mouseleave="openMenu = false"
                 class="bb-client-balance-menu-icon__popup"
            >
              <div class="bb-client-balance-menu-icon__item"
                   :class="{'bb-client-balance-menu-icon__item_disabled': !accessMassMailing}"
                   v-for="(itemMenu, index) in popupMenu"
                   :key="itemMenu.title + index"
                   v-if="itemMenu.action"
                   @click.stop="clickToMenu(itemMenu)"
              >
                {{itemMenu.title}}
              </div>
            </div>
          </transition>
        </i>
      </div>
      <Table :options="options"/>
    </div>
    <transition name="fade" mode="out-in">
      <ExportExcel :columns="balanceColumns"
                   v-if="openClientExport"
                   :withoutColumns="false"
                   :data="exportParams"
                   keyColumnsSettings="balanceParams"
                   file-name="client-balances"
                   :generateExcel="generateExcel"
                   @close="openClientExport = false"/>
    </transition>
  </div>
</template>

<script>
import Table from '@/components/Main/Table/Table'
import ExportExcel from '@/components/Main/ExportExcel/ExportExcel'
import TotalCard from '@/components/Finance/InvoiceTable/TotalCard/TotalCard'
import ContactsApi from '@/api/Contacts/api'
import {balanceClientsTable, balanceClientsTableColumns} from '@/constants/TablesOptions/balanceClientsTable'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import {get, forEach} from 'lodash'
import {FOUNDER} from '@/constants/roles'

export default {
  name: 'BalanceClients',
  components: {
    Table,
    TotalCard,
    LoaderFly,
    ExportExcel
  },
  data: function () {
    return {
      loaderRun: false,
      options: balanceClientsTable,
      openMenu: false,
      exportParams: {},
      openClientExport: false,
      popupMenu: [
        {title: 'Export Clients', action: this.exportContacts}
      ],
      totalsInvoicesCard: {
        totalAccountBalance: {
          id: 0,
          title: 'TOTAL',
          icon: 'icon-coins',
          sum: 0
        },
        totalSoa: {
          id: 3,
          title: 'SOA TOTALS',
          icon: 'icon-coins',
          sum: 0
        },
        totalCreditNote: {
          id: 4,
          title: 'UNNAPPLIED CREDIT NOTES',
          icon: 'icon-coins',
          sum: 0
        },
        totalOverpaid: {
          id: 2,
          title: 'TOTAL OVERPAID',
          color: 'green',
          icon: 'icon-coins',
          sum: 0
        },
        totalUnderpaid: {
          id: 1,
          title: 'TOTAL UNDERPAID',
          color: 'red',
          icon: 'icon-coins',
          sum: 0
        }
      },
      balanceColumns: [
        {
          title: 'FIRST NAME',
          property: 'firstName'
        },
        {
          title: 'LAST NAME',
          property: 'lastName'
        },
        {
          title: 'NICKNAME',
          property: 'nickName'
        },
        {
          title: 'BALANCE, AED',
          property: 'balanceAed'
        },
        {
          title: 'STATUS',
          property: 'status'
        },
        {
          title: 'OVER- AND UNDERPAYMENTS, AED',
          property: 'underPayments'
        }
      ]
    }
  },
  computed: {
    balanceClientsColumnsData: {
      get: function () {
        return this.$store.getters.balanceClientsColumnsData
      },
      set: function (data) {
        this.$store.dispatch('setBalanceClientsColumnsData', data)
      }
    },
    balanceClientsRowsData: {
      get: function () {
        return this.$store.getters.balanceClientsRowsData
      },
      set: function (data) {
        this.$store.dispatch('setBalanceClientsRowsData', data)
      }
    },
    accessMassMailing () {
      const userInfo = this.$store.getters.userInfo
      const isFounder = userInfo.role === FOUNDER.id
      return isFounder || get(userInfo, 'massMailingCheck', '')
    }
  },
  methods: {
    addActions () {
      forEach(this.balanceClientsColumnsData, item => {
        item.get = this.getContactsList
      })
    },
    closeMenu () {
      this.openMenu = false
    },
    clickToMenu (item) {
      if (!this.accessMassMailing) return
      if (typeof item.action === 'function') item.action()
    },
    exportContacts () {
      this.openClientExport = true
      this.exportParams = {
        clientIDs: this.balanceClientsRowsData.map(item => item._id),
        excelParams: {
          modeOfPayment: 'MODE OF PAYMENT',
          date: 'DATE',
          taxInvoiceNumber: 'TAX INV NO.',
          outgoing: 'OUTGOING, AED',
          breakdownInc: 'BREAKDOWN, 3RD',
          breakdownExc: 'BREAKDOWN, OUR',
          incoming: 'INCOMING, AED',
          description: 'DESCRIPTION',
          balanceAed: 'BALANCE, AED'
        },
        balanceParams: {
          firstName: 'First Name',
          lastName: 'Last Name',
          nickName: 'Nickname',
          balanceAed: 'Balance AED',
          status: 'Status',
          underPayments: 'Over and UnderPayments'
        }
      }
    },
    async generateExcel (data) {
      const resp = await ContactsApi.getContactBalances(data)
      return resp
    },
    getContactsList ({query = ''}) {
      this.loaderRun = true
      ContactsApi.getContactsListPositive({query})
        .then((resp) => {
          this.balanceClientsRowsData = resp.data.docs
          this.loaderRun = false
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    getContactsTotal () {
      ContactsApi.getContactsTotals()
        .then((resp) => {
          this.totalsInvoicesCard.totalOverpaid.sum = resp.data.totalOverpaid
          this.totalsInvoicesCard.totalUnderpaid.sum = resp.data.totalUnderpaid
          this.totalsInvoicesCard.totalAccountBalance.sum = resp.data.totalBalance
          this.totalsInvoicesCard.totalSoa.sum = resp.data.totalSoa
          this.totalsInvoicesCard.totalCreditNote.sum = resp.data.totalCreditNote
        })
        .catch((err) => {
          console.error(err)
        })
    }
  },
  beforeMount () {
    this.balanceClientsColumnsData = balanceClientsTableColumns
    this.addActions()
    this.getContactsList({})
    this.getContactsTotal()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/_variables";
  @import "../../../../sass/mixins";

  .bb-client-balance {
    &-menu {
      position: relative;
      display: flex;
      justify-content: flex-end;
      z-index: 3;

      &-icon {
        position: absolute;
        padding: 19px 16px;
        top: -60px;
        transform: rotate(90deg);
        color: $color-accent;
        font-size: 20px;
        cursor: pointer;
        transition: 0.3s;

        &__popup {
          position: absolute;
          left: -22px;
          top: 86px;
          transform: rotate(-90deg);
          background: $color-white;
          box-shadow: 0 0 10px rgba($color-black, 0.1);
          border-radius: 5px;
          padding: 5px 0;
          min-width: 190px;
          transition: 0.3s;
        }

        &__item {
          @include global-font;
          padding: 13px 18px;
          font-weight: 300;
          font-size: 13px;
          line-height: 16px;
          white-space: nowrap;
          color: $color-black;
          cursor: pointer;
          transition: 0.3s;
          user-select: none;

          &_disabled {
            pointer-events: none;
            color: $color-silver-chalice;
          }

          &:hover {
            background-color: $color-wild-sand;
          }
        }

        &:hover {
          color: $color-accent-hover;
        }
      }
    }

    &-totals {
      display: grid;
      grid-template-columns: repeat(auto-fill, 212px);
      margin-bottom: 15px;
      margin-top: 30px;
      grid-gap: 20px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Finance/Income/BalanceClients/BalanceClients.vue